import React from 'react';

function PrivacyEnglish() {
  return (
    <div>
      <h1>POLICY for Cookies </h1>
      Vivian Lab URL: https://vivianlab.com
      <br />
      <br />
      Statement: By accessing and maintaining access to this website, you expressly accept the
      following Cookie Policy. Last Revision of this: 16th/November/2023
      <br />
      <br />
      GENERALLY
      <br />
      The "Company" adheres to a strict policy to protect the privacy of "Website" visitors. With
      this note we provide you with more information on how we use electronic cookies - COOKIES ,
      every time you visit our website. We consider it important that the user has information about
      which cookies we use on our website and for what reasons we use them. Our goal is correct
      information as well as better and safer navigation on our Company's website.
      <br />
      DEFINITION What are Cookies ? <br />
      <br />
      Electronic cookies are short pieces of software code, which are sent to be stored by our
      Company's online server (" server ") on your terminal equipment with their basic function of
      communicating with us using the data of your browser (" browser "). Depending on their
      duration, cookies are either "temporary" ( session cookies ) or "persistent" ( persistent
      cookies ). "Temporary cookies " are cookies that are automatically deleted when you close your
      browser , while "persistent cookies " remain stored on your terminal equipment until the
      completion of their predetermined validity period. The acceptance and use of cookies in no way
      cause damage to the terminal equipment you use, such as for example PC , Smartphone , tablet ,
      nor to the files you keep on it.
      <br />
      <br />
      REASONS FOR USING cookies
      <br />
      Does our website use cookies ?<br />
      We do use some electronic cookies with the main purpose of making our website
      "www.vivianlab.com" more functional and more user-friendly, improving its general operation,
      correct and fast navigation, easy connection and smooth movement to the individual pages us.
      In addition, cookies are used to facilitate the visitor/user's access to the services of the
      "Website" but also for statistical reasons in order to determine the areas in which the
      services of the "Website" are useful or popular. All information collected by these cookies is
      used to improve the shopping experience, structure, content and immediacy of our website.
      Also, with the use of cookies we achieve the continuous optimization of the operation of the
      website and the provision of services of our Company as well as the immediate treatment of any
      problems that may arise.
      <br />
      <br />
      TYPES OF COOKIES WE USE.
      <br />
      cookie technology and specifically:
      <br />
      The "temporary cookies " ( session cookies ) for the following purposes:
      <br />
      - To automatically identify you as a registered user after logging in or for browsing secure
      subpages .<br />
      - For your automatic identification when performing transactions as well as using our services
      and which are necessary for the operation of the usual service selection application.
      <br />
      - To distribute the processing of server requests among a group of servers.
      <br />
      - For the electronic identification of users already connected to social media
      <br />
      Furthermore, we use "persistent cookies " for the following purposes:
      <br />
      - To improve the performance of our website.
      <br />
      - To personalize your interface and personalize the operation of our website.
      <br />
      <br />
      <br />
      CATEGORIES Cookies we use.
      <br />
      1) Necessary Cookies
      <br />
      <br />
      They allow the execution of basic functions of the site, such as adding services, online
      payment and saving your choices and preferences in the service list. Without these absolutely
      necessary Cookies , the smooth operation of our website is immediately affected, but the
      personal navigation experience is also degraded, since the options and functions that are
      essential for online use are underpowered.
      <br />
      2) Performance cookies
      <br />
      cookies collect information about how visitors use our website . They allow us to see which
      pages are visited most often or show us if they are experiencing any problems while
      navigating. These cookies do not collect information that identifies the visitor. All
      information collected by these cookies is aggregated and used only to improve the way our
      website works.
      <br />
      3) Functionality cookies
      <br />
      These cookies "remember" the user's preferences when browsing our site, so that we can then
      proportionally recommend the appropriate services and options based on the user's needs. With
      these cookies , a personalized version of the website is created, making it much easier for
      the user to find what they are looking for.
      <br />
      4) Advertising cookies
      <br />
      These cookies are used to provide advertisements more relevant to each user and their
      interests. They are also used to send targeted advertising or offers with the aim of limiting
      bulk, spam and irrelevant advertising messages to the user. At the same time, they help
      measure the effectiveness of advertising campaigns.
      <br />
      5) Cookies Analytics
      <br />
      They are a subset of Functionality Cookies and enable us to evaluate the effectiveness of the
      various functions of our site, so that we can continuously improve the experience we offer to
      the user.
      <br />
      Specifically:
      <br />
      <br />
      Third-party vendors, including Google , may display Company advertisements on Internet sites .
      <br />
      Third party vendors, including Google , may use cookies to update, optimize and display
      advertisements based on the user's previous visit to our website .
      <br />
      website may also use cookies from a previous visit to its website for remarketing.
      <br />
      The user can opt out of such use of cookies through the options and process protocols proposed
      by the respective browser .
      <br />
      The user can set the browser to be informed every time before a cookie is downloaded and
      therefore decide to download it or reject it. In this case, we inform you that you may not be
      able to use all its features.
      <br />
      The website may use Google functions Analytics for display ads (eg, remarketing, Google
      Display Network impression reports, Doubleclick Campaign Manager integration, and demographic
      and interest reports).
      <br />
      Using the Ads Settings , users can opt out of Google Analytics for display ads and customize
      Google Display Network ads .
      <br />
      Here are the Google opt -out options available Analytics for the web.
      <br />
      The site complies with Google 's Interest-Based Advertising Policy AdWords and restrictions
      for sensitive categories and: Uses remarketing with Google Analytics for online advertising.
      <br />
      The website and third-party service providers , including Google , together use first - party
      cookies (such as the Google Analytics ) and third-party cookies (such as cookie DoubleClick ),
      to update, optimize and serve ads based on some users' past visits to its website .
      <br />
      The website and third-party service providers , including Google , together use first - party
      cookies (such as the Google Analytics ) and third-party cookies (such as cookie DoubleClick ),
      to run reports on how the website's ad impressions, other uses of advertising services and
      interactions with those ad impressions and advertising services relate to visits to the
      website.
      <br />
      The website may use data from Google 's interest-based advertising or third-party audience
      data (such as age, gender and interests) with Google Analytics .
      <br />
      The Company reserves the right to change this cookie policy at any time. Please locate the
      point "LAST REVISION" at the top of this page, to see when this Cookies Policy was last
      revised . Any changes to this Cookies Policy will be effective from the moment the revised
      Cookies Policy becomes available on the Website.
      <br />
      Third-party advertisers and other businesses we work with may use their own Cookies to collect
      information about user activities on our Site. It is mentioned that our company does not
      control these Cookies .
      <br />
      <br />
      DISABLE Cookies in particular.
      <br />
      You can activate, deactivate or completely delete cookies through the settings options in the
      browser you use. If you choose to disable cookies , some parts of the website may not work
      properly and therefore users accept this intervention from the beginning. You can visit the
      website without having allowed the intervention of cookies , but you will not be able to use
      all the features of the website or enjoy its specific features. To change your cookie settings
      , see your browser 's "Help" menu
      <br />
      <br />
      ESPECIALLY about data for executed transactions.
      <br />
      How is Consent for the Acceptance of the Above Use of Cookies given by the user? When the user
      enters the main page of the "Website", he becomes aware of a relevant note on our use of
      cookies , which is in a prominent position and refers to this policy of use with relevant
      clear and extensive information. In the event that the user decides to browse sub-pages of the
      "Website" and if he has properly configured the web browser , he freely provides express and
      specific consent for this use. Otherwise, the user must refrain from browsing the "Website" or
      disable the use of cookies in the browser settings .
      <br />
      <br />
      How can the user disable the use of Cookies ?
      <br />
      In the event that the user wishes to activate or deactivate the use of electronic cookies from
      the browser settings , depending on the browser , we recommend visiting the following
      websites, to learn about the necessary related actions
      <br />● <a href="http://support.microsoft.com/kb/278835">Internet Explorer</a> <br />●{' '}
      <a href="http://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored">
        Firefox
      </a>{' '}
      <br />● <a href="http://support.google.com/accounts/answer/61416?hl=en">Chrome</a> <br />●{' '}
      <a href="http://www.opera.com/browser/tutorials/security/privacy/">Opera</a> <br />●{' '}
      <a href="http://support.apple.com/kb/PH5042">
        Safari <br />
      </a>
      ● <a href="http://support.apple.com/kb/HT1677">Safari</a> <br /> <br />
      Finally, our Company remains always at your disposal for any information and/or further
      clarification and question you wish to contact us.
    </div>
  );
}

export default PrivacyEnglish;
